import { render, staticRenderFns } from "./CreateProtectedUrl.vue?vue&type=template&id=1a2fe2a0&"
import script from "./CreateProtectedUrl.vue?vue&type=script&lang=js&"
export * from "./CreateProtectedUrl.vue?vue&type=script&lang=js&"
import style0 from "./CreateProtectedUrl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a2fe2a0')) {
      api.createRecord('1a2fe2a0', component.options)
    } else {
      api.reload('1a2fe2a0', component.options)
    }
    module.hot.accept("./CreateProtectedUrl.vue?vue&type=template&id=1a2fe2a0&", function () {
      api.rerender('1a2fe2a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/ProtectedUrls/CreateProtectedUrl.vue"
export default component.exports